import { Capacitor } from "@capacitor/core";

const isNative = () => Capacitor.isNativePlatform?.() || ["ios", "android"].includes(Capacitor.getPlatform());
let activeRewardPromise = null;

const getRewardedAdId = () => {
	const platform = Capacitor.getPlatform();
	if (platform === "ios") return import.meta.env.VITE_ADMOB_IOS_REWARDED_ID;
	return import.meta.env.VITE_ADMOB_ANDROID_REWARDED_ID;
};

export const initializeAds = async () => {
	if (!isNative()) return { native: false, ready: true };

	const { AdMob } = await import("@capacitor-community/admob");
	await AdMob.initialize({
		initializeForTesting: import.meta.env.VITE_ADMOB_TESTING !== "false",
	});

	return { native: true, ready: true };
};

export const showRewardedAd = async ({ rewardId, userId }) => {
	if (activeRewardPromise) {
		throw new Error("A rewarded ad is already opening.");
	}

	activeRewardPromise = (async () => {
		if (!isNative()) {
			await new Promise((resolve) => window.setTimeout(resolve, 650));
			return {
				granted: true,
				mocked: true,
				rewardItem: { type: rewardId, amount: 1 },
			};
		}

		const adId = getRewardedAdId();
		if (!adId) throw new Error("Missing rewarded ad unit id for this platform.");

		const options = {
			adId,
			isTesting: import.meta.env.VITE_ADMOB_TESTING !== "false",
			immersiveMode: true,
		};
		if (userId) options.ssv = { userId, customData: JSON.stringify({ rewardId }) };

		const { AdMob } = await import("@capacitor-community/admob");
		await AdMob.prepareRewardVideoAd(options);
		const rewardItem = await AdMob.showRewardVideoAd();

		return {
			granted: true,
			mocked: false,
			rewardItem,
		};
	})();

	try {
		return await activeRewardPromise;
	} finally {
		activeRewardPromise = null;
	}
};
